import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import {
  viewerPhotoDocumentsRejectInit,
  viewerPhotoDocumentsReject,
} from '../../actions/Viewer/ViewerActions';

import Modal from '../Modal';

import {
  Form,
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Button,
  Box,
  Textbox,
  Text,
} from './PhotoDocumentsReject.style';
// import { Breakpoints } from '../../assets/Variables.style';

const PhotoDocumentsRejectInner = ({
  ids,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const dispatch = useDispatch();
  const firebaseStore = useSelector((state) => state.firebase);
  const { profile } = firebaseStore;
  const isProfileCompany = profile.company && profile.company.id ? true : false;

  const viewerPhotoDocumentsRejectStore = useSelector(
    (state) => state.viewerPhotoDocumentsRejectStore
  );
  const {
    isLoading,
    isSuccess,
    isError,
    error,
  } = viewerPhotoDocumentsRejectStore;

  const onSubmit = (e) => {
    e.preventDefault();
    if (isProfileCompany) {
      dispatch(viewerPhotoDocumentsReject({ ids }));
    }
  };

  useEffect(() => {
    dispatch(viewerPhotoDocumentsRejectInit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleProcess(isLoading ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSuccess, isError]);

  const renderSuccessPanel = () => {
    return (
      <Wrapper theme={theme.photoDocumentsReject.wrapper}>
        <Header theme={theme.photoDocumentsReject.header}>
          <Title theme={theme.photoDocumentsReject.title}>
            {intl.formatMessage({
              id: 'REJECT_PHOTO_DOCUMENT.SUCCESS',
            })}
          </Title>
        </Header>
        <Content>
          <Box>
            <Textbox center>
              <Text theme={theme.photoDocumentsReject.text.default}>
                {intl.formatMessage({
                  id: `REJECT_PHOTO_DOCUMENTS.TEXT.THE_PHOTO_DOCUMENTS_HAVE_BEEN_SUCCESSFULLY_REJECTED`,
                })}
              </Text>
            </Textbox>
          </Box>
        </Content>
        <Footer>
          <Button
            type='button'
            theme={theme.button.default}
            onClick={() => {
              handleClose();
            }}
          >
            {intl.formatMessage({ id: 'REJECT_PHOTO_DOCUMENTS.OK' })}
          </Button>
        </Footer>
      </Wrapper>
    );
  };

  return (
    <>
      {isSuccess ? (
        renderSuccessPanel()
      ) : (
        <Form onSubmit={onSubmit}>
          <Wrapper theme={theme.photoDocumentsReject.wrapper}>
            <Header theme={theme.photoDocumentsReject.header}>
              <Title theme={theme.photoDocumentsReject.title}>
                {intl.formatMessage({
                  id: 'REJECT_PHOTO_DOCUMENTS.REJECT_PHOTO_DOCUMENTS',
                })}
              </Title>
            </Header>
            <Content>
              <Box>
                <Textbox center>
                  <Text theme={theme.photoDocumentsReject.text.default}>
                    {intl.formatMessage({
                      id: `REJECT_PHOTO_DOCUMENTS.TEXT.ARE_YOU_SURE_WANT_TO_REJECT_PHOTO_DOCUMENTS`,
                    })}
                    <br />
                    {intl.formatMessage({
                      id: `REJECT_PHOTO_DOCUMENTS.TEXT.THIS_OPERATION_CANNOT_BE_UNDONE`,
                    })}
                  </Text>
                </Textbox>
              </Box>
            </Content>
            {isError ? (
              <Textbox>
                <Text theme={theme.photoDocumentsReject.text.error}>
                  {intl.formatMessage({
                    id: `REJECT_PHOTO_DOCUMENTS.TEXT.ERROR.${error}`,
                    defaultMessage: error,
                  })}
                </Text>
              </Textbox>
            ) : (
              ''
            )}
            <Footer>
              <Button
                type='button'
                theme={theme.button.alt}
                disabled={isLoading}
                onClick={() => {
                  handleClose();
                }}
              >
                {intl.formatMessage({ id: 'REJECT_PHOTO_DOCUMENTS.CANCEL' })}
              </Button>
              <Button theme={theme.button.default} disabled={isLoading}>
                {isLoading
                  ? intl.formatMessage({
                      id: 'REJECT_PHOTO_DOCUMENTS.PLEASE_WAIT',
                    })
                  : intl.formatMessage({
                      id: `REJECT_PHOTO_DOCUMENTS.REJECT`,
                    })}
              </Button>
            </Footer>
          </Wrapper>
        </Form>
      )}
    </>
  );
};

const PhotoDocumentsReject = ({
  ids,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  // const [width] = useWindowSize();
  return (
    <Modal
      handleClose={handleClose}
      // fullscreen={width <= Breakpoints.md ? true : false}
    >
      <PhotoDocumentsRejectInner
        ids={ids}
        handleClose={handleClose}
        handleProcess={handleProcess}
      />
    </Modal>
  );
};

PhotoDocumentsRejectInner.propTypes = {
  ids: PropTypes.array,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

PhotoDocumentsReject.propTypes = {
  ids: PropTypes.array,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

export default PhotoDocumentsReject;
